import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      valueField: "id",
      labelField: "title",
      searchField: "title",
      create: false,
      preload: false,
      loadThrottle: 300,
      load: (query, callback) => {
        if (!query.length) return callback()

        const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
        fetch(url)
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback())
      }
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
